import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, RequestOptions } from '@angular/http';
import { AppComponent} from './app.component';
import { TopMenuComponent} from './top-menu/top-menu.component';
import { HomeComponent} from './home/home.component';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { routerConfig } from "./router.config";
import { RouterModule } from "@angular/router";
import { LoginComponent } from './shared/login/login.component';
import { RegisterComponent } from './register/register.component';
import { AngularFireModule } from "angularfire2";
import { firebaseConfig } from "../environments/firebase.config";
import { AuthService } from "./shared/security/auth.service";
import { StateDataService } from "./shared/services/state/state-data.service";
import { DropdownModule } from "ng2-dropdown";
import { TransitionComponent } from './transition/transition.component';
import { AuthGuard} from "./shared/security/auth-guard";
import { FloowUsComponent } from './contact-us/floow-us/floow-us.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { TransGuard } from "./shared/security/trans-guard";
import { ModalModule } from "angular2-modal";
import { BootstrapModalModule } from "angular2-modal/plugins/bootstrap";
import { MainComponent } from './main/main.component';
import { RestaurantTableComponent } from './restaurant/restaurant-table/restaurant-table.component';
import { Ng2TableModule } from "ng2-table";
import { TableTableComponent } from './table/table-table/table-table.component'
import { TableService } from "./shared/services/table/table.service";
import { UserTableComponent } from './user/user-table/user-table.component';
import { RestaurantFormComponent } from './restaurant/restaurant-form/restaurant-form.component';
import { RestaurantCreateComponent } from './restaurant/restaurant-create/restaurant-create.component';
import { RestaurantEditComponent } from './restaurant/restaurant-edit/restaurant-edit.component';
import { RestaurantResolver } from "./shared/services/restaurant/restaurant-resolver";
import { UserService } from "./shared/services/user/user.service";
import { TableEditComponent } from './table/table-edit/table-edit.component';
import { TableCreateComponent } from './table/table-create/table-create.component';
import { TableFormComponent } from './table/table-form/table-form.component';
import { TableResolver } from "./shared/services/table/table-resolver";
import { PaginationModule } from "ng2-bootstrap";
import { TableCreateMultipleComponent } from './table/table-create-multiple/table-create-multiple.component';
import { PrintQRCodesComponent } from './table/print-qrcodes/print-qrcodes.component';
import { UserFormComponent } from './user/user-form/user-form.component';
import { UserEditComponent } from './user/user-edit/user-edit.component';
import { UserResolver } from "./shared/services/user/user-resolver";
import { UserSendCodeComponent } from './user/user-send-code/user-send-code.component';
import { UserRegisterComponent } from './user/user-register/user-register.component';
import { DownloadComponent } from './download/download.component';
import { AngularFireDatabaseModule } from "angularfire2/database";
import { AngularFireAuthModule } from "angularfire2/auth";
import { PaymentComponent } from './payment/payment.component';
import { RestaurantService } from "./shared/services/restaurant/restaurant.service";
import { RestaurantSubscriptionComponent } from './restaurant/restaurant-subscription/restaurant-subscription.component';
import { Ng2SmartTableModule } from "ng2-smart-table";
import { LocalStripeService } from "./shared/services/stripe/local.stripe.service";
import { TabsModule } from 'ngx-bootstrap/tabs';
import { DefaultRequestOptions} from "./shared/services/stripe/default-request-options";
import { InvoiceHistoryComponent } from './invoice/invoice-history/invoice-history.component';
import { CurrencyPipe, DatePipe} from "@angular/common";
import { CreditCardCreateComponent } from './credit-card/credit-card-create/credit-card-create.component';
import { NgxStripeModule } from 'ngx-stripe';
import { CreditCardEditComponent } from './credit-card/credit-card-edit/credit-card-edit.component';
import { InvoiceDetailComponent } from './invoice/invoice-detail/invoice-detail.component';
import { InvoiceResolver } from "./shared/services/stripe/invoice-resolver";
import { InvoiceEmailEditComponent } from './invoice/invoice-email-edit/invoice-email-edit.component';
import { CustomerResolver } from "./shared/services/stripe/customer-resolver";
import { EmailUsComponent } from './contact-us/email-us/email-us.component';
import { MapsService } from "./shared/services/maps/maps.service";
import { InvitationCodesComponent } from './beta-codes/invitation-codes/invitation-codes.component';
import { NgxQRCodeModule } from "ngx-qrcode2";
import { TablesRaitingsComponent } from './table/tables-raitings/tables-raitings.component';
// import { MatTableModule } from "@angular/material";


@NgModule({
  declarations: [
    AppComponent,
    TopMenuComponent,
    HomeComponent,
    LoginComponent,
    RegisterComponent,
    TransitionComponent,
    FloowUsComponent,
    LoginPageComponent,
    MainComponent,
    RestaurantTableComponent,
    TableTableComponent,
    UserTableComponent,
    RestaurantFormComponent,
    RestaurantCreateComponent,
    RestaurantEditComponent,
    TableEditComponent,
    TableCreateComponent,
    TableFormComponent,
    TableCreateMultipleComponent,
    PrintQRCodesComponent,
    UserFormComponent,
    UserEditComponent,
    UserSendCodeComponent,
    UserRegisterComponent,
    DownloadComponent,
    PaymentComponent,
    RestaurantSubscriptionComponent,
    InvoiceHistoryComponent,
    CreditCardCreateComponent,
    CreditCardEditComponent,
    InvoiceDetailComponent,
    InvoiceEmailEditComponent,
    EmailUsComponent,
    InvitationCodesComponent,
    TablesRaitingsComponent,


  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    NgbModule.forRoot(),
    RouterModule.forRoot(routerConfig),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    ReactiveFormsModule,
    DropdownModule,
    ModalModule.forRoot(),
    BootstrapModalModule,
    Ng2TableModule,
    Ng2SmartTableModule,
    PaginationModule.forRoot(),
    TabsModule.forRoot(),
    NgxStripeModule.forRoot('pk_test_Idet6pzanLcwW7vr1dwYh2Wu'),
    NgxQRCodeModule,
    // MatTableModule

  ],
  providers: [
    AuthService,
    StateDataService,
    RestaurantService,
    AuthGuard,
    TransGuard,
    TableService,
    RestaurantResolver,
    UserService,
    TableResolver,
    UserResolver,
    LocalStripeService,
    DatePipe,
    CurrencyPipe,
    InvoiceResolver,
    CustomerResolver,
    MapsService,
      {
        provide: RequestOptions,
        useClass: DefaultRequestOptions
      }
    ],

  bootstrap: [
    AppComponent
  ],

})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts